import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const tenantBotsSlice = createSlice({
  name: "tenantBots",
  initialState,
  reducers: {
    setTenantBots: (state, action) => action.payload,
  },
});

export const { setTenantBots } = tenantBotsSlice.actions;
export default tenantBotsSlice.reducer;
